import {StateSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/StateSet";

export enum PearlHarborToggleState {
    OFF = 0,
    ON1,
    ON2,
}

/**
 * Generic set for toggle states.
 */
export class PearlHarborToggleStateSet<T> implements StateSet<T> {
    [PearlHarborToggleState.OFF]?:T;
    [PearlHarborToggleState.ON1]:T;
    [PearlHarborToggleState.ON2]:T;

    constructor(on1:T,on2:T, off?:T) {
        this[PearlHarborToggleState.ON1] = on1;
        this[PearlHarborToggleState.ON2] = on2;
        this[PearlHarborToggleState.OFF] = off;
    }

    /**
     *
     * @param state
     * @return returns Item for state, falls back to ToggleState.ON
     */
    public getItem(state:PearlHarborToggleState):T {
        return this[state] != undefined ? this[state]! : this[PearlHarborToggleState.ON1]!;
    }

    clone():PearlHarborToggleStateSet<T> {
        return new PearlHarborToggleStateSet(
            this[PearlHarborToggleState.ON1],
            this[PearlHarborToggleState.ON2],
            this[PearlHarborToggleState.OFF]
        );
    }
}